var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14849_1934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 2.33337C9.48201 2.33354 9.62502 2.39047 9.73313 2.49254C9.84124 2.5946 9.9063 2.7341 9.91502 2.88252C9.92373 3.03095 9.87544 3.1771 9.78001 3.29111C9.68458 3.40512 9.54922 3.4784 9.40158 3.49596L9.33333 3.50004H3.20833C3.13545 3.49991 3.06515 3.52707 3.01129 3.57617C2.95743 3.62528 2.92391 3.69277 2.91732 3.76535C2.91074 3.83794 2.93157 3.91036 2.97571 3.96836C3.01986 4.02636 3.08411 4.06572 3.15583 4.07871L3.20833 4.08337H11.0833C11.3777 4.08328 11.6612 4.19444 11.877 4.39458C12.0928 4.59472 12.225 4.86903 12.2471 5.16254L12.25 5.25004V10.5C12.2501 10.7944 12.1389 11.0779 11.9388 11.2937C11.7387 11.5095 11.4643 11.6417 11.1708 11.6638L11.0833 11.6667H2.91667C2.62233 11.6668 2.33884 11.5556 2.12301 11.3555C1.90719 11.1554 1.77499 10.881 1.75292 10.5875L1.75 10.5V3.79171C1.74994 3.42146 1.89072 3.06504 2.14377 2.79476C2.39683 2.52449 2.74321 2.36058 3.11267 2.33629L3.20833 2.33337H9.33333ZM2.91667 5.22087V10.5H11.0833V5.25004H3.20833C3.14183 5.25004 3.07592 5.24537 3.01175 5.23721L2.91667 5.22087ZM9.04167 7.00004C9.27373 7.00004 9.49629 7.09223 9.66038 7.25632C9.82448 7.42042 9.91667 7.64298 9.91667 7.87504C9.91667 8.1071 9.82448 8.32966 9.66038 8.49376C9.49629 8.65785 9.27373 8.75004 9.04167 8.75004C8.8096 8.75004 8.58704 8.65785 8.42295 8.49376C8.25885 8.32966 8.16667 8.1071 8.16667 7.87504C8.16667 7.64298 8.25885 7.42042 8.42295 7.25632C8.58704 7.09223 8.8096 7.00004 9.04167 7.00004Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14849_1934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.5f799df15dca30aeb76d35e64ae9bb02.svg";
export { ForwardRef as ReactComponent };